import React from "react";

const Page1: React.FC = () => {
  const url = process.env.REACT_APP_API_URL;
  const version = process.env.REACT_APP_VERSION;
  const env = process.env.REACT_APP_ENV;

  return (
    <div>
      <h1>Welcome to Page 1 (V2)</h1>
      <h2>url={url}</h2>
      <h2>version={version}</h2>
      <h2>env={env}</h2>
    </div>
  );
};

export default Page1;
